/**
 * Converts a language (`nl`) to a locale (`nl-NL`) and try to be smart about it.
 *
 * @param language the language code (`nl`), defaults to `en`
 * @param country the country code (`be`), defaults to the `language` parameter
 * @return the corresponding locale
 */
export const languageToLocale = (language = 'en', country: string = language): string =>
  `${language.toLowerCase()}-${country.toUpperCase()}`
